import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Leaf, Heart, Users, Globe } from 'lucide-react';
import { Toaster } from '../components/ui/toaster';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-light text-gray-800 mb-4">Our Story</h1>
          <p className="text-lg text-gray-600">
            Building a jewelry company that values people and planet over profit
          </p>
        </div>
      </div>

      {/* Mission */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <Heart size={48} className="mx-auto text-gray-700 mb-6" />
          <h2 className="text-3xl font-light mb-6 text-gray-800">Our Mission</h2>
          <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
            At Diamond Q Jewelers, our mission is to build a community that changes the way the world sees jewelry through the power of integrity, sustainable and eco-conscious practices, and valuing people and the planet over profit.
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-3 gap-12 mb-16">
          <div className="text-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Leaf size={32} className="text-gray-700" />
            </div>
            <h3 className="text-xl font-normal mb-3 text-gray-800">Sustainability</h3>
            <p className="text-gray-600">
              We use lab-grown diamonds and recycled metals to minimize environmental impact while delivering stunning jewelry.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Users size={32} className="text-gray-700" />
            </div>
            <h3 className="text-xl font-normal mb-3 text-gray-800">Ethical Practices</h3>
            <p className="text-gray-600">
              Every piece is crafted with fair labor practices and no exploitation in our supply chain.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Globe size={32} className="text-gray-700" />
            </div>
            <h3 className="text-xl font-normal mb-3 text-gray-800">Transparency</h3>
            <p className="text-gray-600">
              We believe in complete transparency about our materials, processes, and business practices.
            </p>
          </div>
        </div>

        {/* Responsible Sourcing Section */}
        <div className="bg-gray-50 rounded-lg p-8 md:p-12">
          <h2 className="text-3xl font-light mb-6 text-gray-800 text-center">Responsible Sourcing</h2>
          <div className="prose max-w-none text-gray-700 space-y-4">
            <p className="leading-relaxed">
              As a people and planet over profit company, we are committed to taking thoughtful and impactful steps towards a mindful and responsible approach to our business. It's imperative that we are bold and transparent in the face of injustice, pulling back the curtain on this industry and putting action behind our ethos.
            </p>
            <p className="leading-relaxed">
              <strong>Lab-Grown Diamonds:</strong> Our diamonds are created in controlled laboratory environments using advanced technology. They have the same physical, chemical, and optical properties as mined diamonds, but without the environmental destruction or human rights concerns.
            </p>
            <p className="leading-relaxed">
              <strong>Recycled Metals:</strong> We use recycled gold and platinum whenever possible, reducing the need for new mining and its associated environmental impact.
            </p>
            <p className="leading-relaxed">
              <strong>Ethical Manufacturing:</strong> All our pieces are crafted by skilled artisans who are paid fair wages and work in safe conditions. We maintain direct relationships with our manufacturing partners to ensure ethical practices throughout the supply chain.
            </p>
          </div>
        </div>
      </div>

      <Footer />
      <Toaster />
    </div>
  );
};

export default About;
